var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdeaLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#F4F2ED",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_159_780)",
    d: "M78.5714 184L30.2856 145.714L54.2856 101.143L123.143 128L78.5714 184Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_159_780)",
    d: "M228 81.4285L224.286 197.143L147.429 228L101.143 198.286L168.857 128L139.143 63.1428L165.714 31.1428L228 81.4285Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_159_780)",
    d: "M228 81.4285L167.143 153.429L139.143 63.1428L165.714 31.1428L228 81.4285Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_159_780)",
    d: "M124.286 194L44 223.143L56.8571 178L73.7143 122.571L28 107.143L56.8571 28L119.714 35.7143L181.429 106.286L124.286 194Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M190.571 66.5715H67.1428V190H190.571V66.5715Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.857 166.857H78.5713V174.571H124.857V166.857Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112 92.0001V82.5715H86.2856V92.0001H93.7142V124.286H86.2856V133.714H112V124.286H104.857V92.0001H112Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.571 134.572C132.571 134.572 129.143 133.714 126.571 132.286C124 130.857 121.714 128.857 120 126.857L127.143 118.857C128.571 120.572 130 121.714 131.429 122.572C132.857 123.429 134.571 124 136.286 124C138.286 124 140 123.429 141.429 122C142.571 120.572 143.143 118.572 143.143 115.429V82.5715H154.571V116C154.571 119.143 154.286 121.714 153.429 124C152.571 126.286 151.429 128 149.714 129.714C148.286 131.143 146.286 132.572 144 133.143C141.714 134 139.429 134.572 136.571 134.572Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_780",
    x1: 30.256,
    x2: 123.192,
    y1: 142.541,
    y2: 142.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#B07B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#577BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_780",
    x1: 101.621,
    x2: 254.926,
    y1: 99.086,
    y2: 183.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CB7A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#9E7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#757B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#537BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#387CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#237CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#147CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#0B7CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_780",
    x1: 208.651,
    x2: 165.972,
    y1: 150.615,
    y2: 23.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#CB417E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9E4E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#5365CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#386DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#2374E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#1478F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#0B7BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_159_780",
    x1: 58.63,
    x2: 186.639,
    y1: 75.066,
    y2: 286.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F63462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#DF3A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#C24383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#AD4A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1D76ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaLight);
export default __webpack_public_path__ + "static/media/Idea-Light.2fddcd8d4c0ff1995c0d02f01d836ace.svg";
export { ForwardRef as ReactComponent };